export const ID_TOKEN_KEY = "id_token";
export const ID_LANGUAGE_KEY = "id_language";
export const ID_SAVE_LOGINID_KEY = "id_save_loginid";
export const ID_USER_KEY = "id_user";
